__turbopack_context__.v({
  "submitBtnContainer": "DocumentsUploaderForm-module-scss-module__LkSmbq__submitBtnContainer",
});
